import { mapValues, pick, trim } from 'lodash';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextInput from '../ReusableComponents/TextInput/TextInput';

export default function IndividualFields(props) {
  const [form, setForm] = useState(
    pick(props.form, ['first_name', 'middle_name', 'last_name']),
  );
  const [errors, setErrors] = useState(mapValues(form, () => false));

  const onChange = (e) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
    props.onChange(name, trim(value));
  };

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <TextInput
        fullWidth
        required
        error={!!errors.first_name || !!props.validationErrors?.first_name}
        label="First Name"
        variant="outlined"
        onChange={onChange}
        onBlur={() => {
          setErrors((e) => ({ ...e, first_name: !form.first_name }));
        }}
        name="first_name"
        value={form.first_name || ''}
        id="va-first-name"
        autoComplete="no"
        disabled={props.disabled}
        formHelperText={props.validationErrors?.first_name}
      />
      <TextInput
        fullWidth
        label="Middle Name"
        variant="outlined"
        onChange={onChange}
        name="middle_name"
        value={form.middle_name || ''}
        id="va-middle-name"
        autoComplete="no"
        disabled={props.disabled}
        error={!!props.validationErrors?.middle_name}
        formHelperText={props.validationErrors?.middle_name}
      />
      <TextInput
        fullWidth
        required
        error={!!errors.last_name || !!props.validationErrors?.last_name}
        label="Last Name"
        variant="outlined"
        onChange={onChange}
        onBlur={() => {
          setErrors((e) => ({ ...e, last_name: !form.last_name }));
        }}
        name="last_name"
        value={form.last_name || ''}
        id="va-last-name"
        autoComplete="no"
        disabled={props.disabled}
        formHelperText={props.validationErrors?.last_name}
      />
    </div>
  );
}

IndividualFields.propTypes = {
  form: PropTypes.shape({
    first_name: PropTypes.string,
    middle_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  validationErrors: PropTypes.shape({
    first_name: PropTypes.string,
    middle_name: PropTypes.string,
    last_name: PropTypes.string,
  }),
};
